import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ActionCreator from "../ActionCreator";
import * as Widget from "./Widget2";
import ListItem from "./HecafeBlogListItem";

class HecafeBlogSection extends Component {
  render() {
    let { navActions, content } = this.props;

    return (
      <Wrapper>
        <Widget.Row
          justify="space-between"
          css={`
            margin-bottom: 24.5px;
            max-width: 1035px;
            width: 100%;
            @media screen and (max-width: 600px) {
              margin: 15px;
            }
          `}
        >
          <Widget.Container css="width: 65px;" />
          <Widget.SectionTitle haveMarginBottom={false}>
            好咖文選
          </Widget.SectionTitle>
          <Widget.SeeMoreButton
            label="探索更多"
            onClick={() => navActions.push("/blogs")}
          />
        </Widget.Row>
        <Widget.SectionLine />

        <Widget.MaxWidth width={1035} css="width: 100%;">
          {content.slice(0, 3).map((c, i) => (
            <ListItem key={"blog-list-item" + i} content={c} />
          ))}
        </Widget.MaxWidth>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
`;

export default connect(
  null,
  ActionCreator
)(HecafeBlogSection);
